import Footer from '../../components/Footer';
import Header from '../../components/Header';
import DATA from '../../data/core.json';
import CoreBlock from './components/CoreBlock';

export default function CorePage() {

  return (
    <div>
      <Header />
      <main className='flex flex-col gap-y-[160px] lg:gap-y-[400px] lg:mb-[240px]'>
        {
          DATA.map((item, idx) => <CoreBlock key={idx} index={idx} data={item} />)
        }
      </main>
      <Footer/>
    </div>
  )
}